import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MaintenanceService } from "../../../service/MaintenanceService";
import { normalizeProviderData, Provider } from "../../../model/BusinessProperty";
import { toast } from "react-toastify";
import AAlert from "../../../components/molecules/AAlert";

const BASE_URL: string | undefined = process.env.REACT_APP_FARMER_ANALYSIS_API_URL

const ProvidersForm: React.FC = () => {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [providers, setProviders] = useState<Provider[]>([]);
    const [newValue, setNewValue] = useState('');
    const [alert, setAlert] = useState<{ message: string; type: string; visible: boolean }>({
        message: '',
        type: '',
        visible: false,
    });

    useEffect(() => {
        fetchProperties();
    }, []);

    const fetchProperties = async () => {
        try {

            if (!BASE_URL)
                throw new Error('URL não definida');

            const data = await MaintenanceService.fetchProviders(`${BASE_URL}/maintenance/providers/list`, normalizeProviderData);
            setProviders(data);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching properties:', error);
            navigate('/error');
        }
    };

    const showAlert = (message: string, type: 'success' | 'error' | 'warning' | 'info') => {
        console.log("show alert");
        setAlert({ message, type, visible: true });
    };

    const closeAlert = () => {
        console.log("close alert");
        setAlert({ ...alert, visible: false });
    };

    const handleWeightChange = (index: number, value: string) => {
        const updatedProviders = [...providers];
        updatedProviders[index].weight = parseFloat(value); // Converte para número
        setProviders(updatedProviders);
    };

    const handleActiveChange = (index: number, value: boolean) => {
        const updatedProviders = [...providers];
        updatedProviders[index].active = value;
        updatedProviders[index].weight = 0
        setProviders(updatedProviders);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        let valid = validateWeight();

        if (!valid) {
            showAlert('A soma dos pesos ativos deve ser igual a 1', 'error');

        } else {
            try {
                // Salva as alterações

                await MaintenanceService.updateProviders(`${BASE_URL}/maintenance/providers/edit`, providers);
                showAlert('Alterações salvas com sucesso', 'success');
                fetchProperties();

                //await MaintenanceService.updateProviders(`${BASE_URL}/maintenance/values`, providers);
            } catch (error) {
                console.error('Error saving properties:', error);
                showAlert('Erro ao salvar alterações', 'error');
            }
        }
    };

    const validateWeight = () => {
        const activeProviders = providers.filter(p => p.active);
        const sum = activeProviders.reduce((acc, curr) => acc + curr.weight, 0);
        if (sum !== 1) {
            return false
        }
        else {
            return true;
        }
    }

    return (


        <>
        
            <div className="flex flex-col h-screen">
            {alert.visible && (
                <AAlert message={alert.message} type={alert.type as any} onClose={closeAlert} />
            )}
                <div className="flex flex-col flex-grow overflow-y-auto p-4 bg-gray-100 rounded-md shadow-md">
                    <h1 className="text-lg font-semibold text-gray-700 mb-4">Editar Provedores</h1>
                    {providers.map((provider, index) => (
                        <div key={index} className="mb-6">
                            <label className="block text-sm font-medium text-gray-600">
                                <strong>Nome:</strong> {provider.name}
                            </label>
                            <div className="grid grid-cols-2 gap-4 mt-2">
                                <div>
                                    <label className="block text-sm font-medium text-gray-600 mb-1">
                                        Peso:
                                    </label>
                                    <input
                                        type="number"
                                        value={provider.weight}
                                        onChange={(e) => handleWeightChange(index, e.target.value)}
                                        step="0.1"
                                        min="0"
                                        className="block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                    />
                                </div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        checked={provider.active}
                                        disabled={provider.blockDesactivation}
                                        onChange={(e) => handleActiveChange(index, e.target.checked)}
                                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                    <label className="ml-2 block text-sm text-gray-600">Ativo</label>
                                </div>
                            </div>
                            <hr className="mt-4" />
                        </div>
                    ))}
                </div>

                <div className="sticky bottom-0 p-4 bg-gray-200 shadow-md">
                    <button
                        className="w-full px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-md shadow hover:bg-gradient-to-br focus:outline-none focus:ring-2 focus:ring-blue-300"
                        type="submit"
                        onClick={handleSubmit}
                    >
                        Salvar Alterações
                    </button>
                </div>
            </div>
        </>
    );
};


export default ProvidersForm